import { render, staticRenderFns } from "./CenteredSpinner.vue?vue&type=template&id=384c9640&"
import script from "./CenteredSpinner.vue?vue&type=script&lang=ts&"
export * from "./CenteredSpinner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports